import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.report_assignments_gds"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: { click: _vm.openModalMeta },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("titles.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c("search-tableau", {
                        attrs: { showDomains: false },
                        on: { onSearchQuery: _vm.onSearchQuery },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  staticClass: "table-inca",
                  attrs: {
                    items: _vm.items,
                    headers: _vm.headers,
                    "hide-default-footer": "",
                    "items-per-page": _vm.pagination.limit,
                    page: _vm.pagination.current,
                  },
                  on: {
                    pagination: function ($event) {
                      _vm.pagination.total = $event.itemsLength
                    },
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.object_name",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "text-left" }, [
                            _c("b", { staticClass: "table-name" }, [
                              _vm._v(_vm._s(row.item.object_name)),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.action",
                      fn: function (row) {
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onClickAssign(
                                                      row.item
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(VIcon, [
                                              _vm._v("icon-user_add"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Assign")])]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.logicDelete(
                                                      row.item
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(VIcon, [
                                              _vm._v("icon-delete"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Delete Report")])]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("pagination-vue", {
              attrs: { pagination: _vm.pagination },
              on: { changePagina: _vm.changePagina },
            }),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c("search-tableau", {
                          attrs: { showDomains: false },
                          on: { onSearchQuery: _vm.onSearchQuery },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "dialogs-component",
        {
          ref: _vm.DIALOG_ASSIGN,
          attrs: { title: _vm.$t("frases.assign"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-report-datastudio", {
                key: _vm.key_assign,
                ref: _vm.DIALOG_ASSIGN + "_body",
                attrs: {
                  item: _vm.data_rp,
                  report_id: _vm.data_rp.report_id,
                  readonly: _vm.is_prod_called ? true : false,
                  isChangeRequest: _vm.is_prod_called
                    ? _vm.ACCESS_TYPE_FLOW.VIEWER_ONLY
                    : _vm.ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR,
                  validateLink: _vm.isValidateLink,
                  show_url: true,
                },
                on: { onCloseModal: _vm.onCloseModal, onSave: _vm.refreshItem },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.DIALOG_ASSIGN + "_body"].onSave()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "my-modal-meta",
          attrs: {
            id: "my-modal-meta",
            size: "xl",
            title: "Demo",
            "hide-footer": "",
            "no-close-on-backdrop": true,
            "no-close-on-esc": true,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v(_vm._s(_vm.$t("frases.assign")))]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-meta-report-datastudio", {
            attrs: {
              item: _vm.data_rp,
              report_id: _vm.data_rp.report_id,
              readonly: _vm.is_prod_called ? true : false,
              isChangeRequest: _vm.is_prod_called
                ? _vm.ACCESS_TYPE_FLOW.VIEWER_ONLY
                : _vm.ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR,
              validateLink: _vm.isValidateLink,
              show_url: true,
            },
            on: { onCloseModal: _vm.onCloseModal, onSave: _vm.refreshItem },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }